import React, { useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import { useAppDispatch } from '../store';
import { setParams } from '../reducers/paramsReducer';
import { setGameIdForModal } from '../reducers/uiReducer';
import { GamesRequestParams } from '../types/GamesRequestParams';
import GameContext from '../context/GameContext';

export default function GamesListItemTitle(): React.ReactNode {
  const { game } = useContext(GameContext);
  const dispatch = useAppDispatch();

  const formattedDate = new Date(game.Date).toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });

  // Just the opening name, without the move sequence chess.com appends ("…Gambit 2.fxe5 d6 3.Nf3").
  // Used for the pill text and its hover title.
  const openingName = game.Opening ? game.Opening.replace(/\s+\d+\..*$/, '').trim() : game.Opening;

  // Apply a filter and close the overlay so the user lands on the filtered list.
  const filterBy = (params: Partial<GamesRequestParams>) => {
    dispatch(setParams({ ...params, page: 0 }));
    dispatch(setGameIdForModal(null));
  };

  return (
    <div className="cm-game-meta">
      <div className="cm-meta-facts">
        {/* Date and time control share the top row (date left, TC right); opening spans below. */}
        <div className="cm-meta-facts-row">
          <a
            href="#"
            className="cm-meta-chip"
            onClick={(e) => {
              e.preventDefault();
              filterBy({ from: game.Date.slice(0, 10), to: game.Date.slice(0, 10) });
            }}
          >
            <span className="cm-meta-chip-icon">📅</span>
            {formattedDate}
          </a>
          {game.TimeControl ? (
            <a
              href="#"
              className="cm-meta-chip cm-meta-chip-tc"
              onClick={(e) => {
                e.preventDefault();
                filterBy({ timeControl: game.TimeControl });
              }}
            >
              <span className="cm-meta-chip-icon">⏱️</span>
              {game.TimeControl}
            </a>
          ) : null}
        </div>
        {/* The opening is display-only, so the review isn't navigated away from; the trailing icon
            opens the list filtered on the full name in a new tab. */}
        <div className="cm-meta-chip cm-meta-chip-opening">
          <span className="cm-meta-chip-icon">📖</span>
          <span className="cm-meta-chip-opening-text" title={openingName ?? undefined}>
            Opening: {openingName}
          </span>
          {game.Opening ? (
            <a
              className="cm-meta-chip-open"
              href={`/?opening=${encodeURIComponent(game.Opening)}`}
              target="_blank"
              rel="noopener noreferrer"
              title="Open games with this opening in a new tab"
              aria-label="Open games with this opening in a new tab"
            >
              <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
            </a>
          ) : null}
        </div>
      </div>
    </div>
  );
}
